// cn.js
export default {
  m: {
    lan: [ //  标题导航
      {
        text: '',
        icon: 'https://index.cuican520.com/cuican.png',
        path: ''
      },
      {
        text: 'Home',
        icon: '',
        path: 'index'
      },
      {
        text: 'Product',
        icon: '',
        path: 'product'
      },
      {
        text: 'Service',
        icon: '',
        path: 'service'
      },
      {
        text: 'Contact',
        icon: '',
        path: 'contact'
      }
    ],
    currentlan: 'ENGLISH',
    news: 'Trends and News', //  标题
    foot: [
      {
        text: 'Chinese partner',
        path: 'friends'
      },
      {
        text: 'Consulting service',
        path: 'consult'
      },
      {
        text: 'Patent technology cooperation',
        path: 'skill'
      },
      {
        text: 'Privacy and data protection',
        path: 'data'
      },
      {
        text: 'Copyright description',
        path: 'copyright'
      }
    ],
    area1: [
      {
        id: 1,
        title: 'Brand story',
        desc: 'Set up a Sino-German bridge and integrate the best resources of Germany to serve the Chinese',
        images: 'https://index.cuican520.com/menu1.png',
        path: 'brand'
      },
      {
        id: 2,
        title: 'Raw-food material',
        desc: 'Add the best of your product with the best ingredients',
        images: 'https://index.cuican520.com/menu2.png',
        path: 'gelatin'
      },
      {
        id: 3,
        title: 'Derivative service',
        desc: 'Provide quality service with our professionalism',
        images: 'https://index.cuican520.com/menu3.png',
        path: 'medical'
      },
      {
        id: 4,
        title: 'Independent product',
        desc: 'Remove acne without leaving marks, create perfect skin and make you feel good all day.',
        images: 'https://index.cuican520.com/menu4.png',
        path: 'branddetail'
      }
    ],
    product: { //  产品
      producttype: 'Product Categories',
      productlist: [
        {
          text: 'raw material',
          pid: 1
        },
        {
          text: 'German brand',
          pid: 2
        },
        {
          text: 'own brand',
          pid: 3
        }
      ],
      productshow: 'Product display',
      productshowarray: {
        materiel: [ //  原物料
          {
            id: 1,
            text: 'Gelatin',
            images: 'https://index.cuican520.com/gelatin.png',
            path: 'gelatin',
            children: {
              mod1: {
                title: `Ewald is a wholly-owned company specializing in the production of the family of Glydding. In the factory just 100 km from Frankfurt, 170 employees are producing all day round throughout the year. The factory uses the best available technology to produce high-quality gelatin exports nationwide.`,
                list: [
                  {
                    title: `1886`,
                    desc: `Construction of production colloids`
                  },
                  {
                    title: `1906`,
                    desc: `Production of edible gelatin`
                  },
                  {
                    title: `1946`,
                    desc: `Rebuilding the factory after World War II`
                  },
                  {
                    title: `1972`,
                    desc: `Producing gelatine from pig skin`
                  },
                  {
                    title: `2004`,
                    desc: `Production of organic gelatin`
                  },
                  {
                    title: `2010`,
                    desc: `Gelitin fine powder production line`
                  },
                  {
                    title: `2013`,
                    desc: `Implementation of new raw materials factory`
                  }
                ]
              },
              mod2: [ //  主要产品
                {
                  title: `Gelitin`,
                  img: `https://index.cuican520.com/gelatin_jld1.png`
                },
                {
                  title: `Gelatine powder`,
                  img: `https://index.cuican520.com/gelatin__jld2.png`
                }
              ],
              mod3: [ //  市场份额
                {
                  title: ``,
                  img: `https://index.cuican520.com/gelatin__area1.png`
                },
                {
                  title: ``,
                  img: `https://index.cuican520.com/grlatin__area2.png`
                }
              ],
              mod4: [ //  质量控制
                {
                  title: ``,
                  img: `https://index.cuican520.com/gelatin__zl.png`
                }
              ],
              mod5: [ //  质量证书
                {
                  title: `FSSC 22000`,
                  img: `https://index.cuican520.com/gelatin__zls1.png`
                },
                {
                  title: `DIN-ISO 9001:2008`,
                  img: `https://index.cuican520.com/gelatin__zls2.png`
                },
                {
                  title: `HACCP`,
                  img: `https://index.cuican520.com/gelatin__zls3.png`
                },
                {
                  title: `BIO(organic) certificate`,
                  img: `https://index.cuican520.com/gelatin__zls4.png`
                }
              ],
              mod6: [ //  产品信息
                {
                  title: ``,
                  img: `https://index.cuican520.com/gelatin__rule.png`
                }
              ],
              mod7: [ //  产品包装
                {
                  title: ``,
                  img: `https://index.cuican520.com/gelatin__pag.png`
                },
                {
                  title: ``,
                  img: `https://index.cuican520.com/gelatin__pag2.png`
                }
              ]
            }
          },
          { //  胶原蛋白
            id: 2,
            text: 'Collagen',
            images: 'https://index.cuican520.com/pro1.png',
            path: 'gelatin',
            children: {
              mod1: {
                title: `Collagen is present in all multicellular animals and is the most abundant type of protein in the body and is found in almost all tissues. It is an extracellular protein that exists as an insoluble fiber with a high tensile strength and is a major factor in determining the toughness of connective tissue. Collagen is rich in amino acids such as glycine, proline and hydroxyproline required by the human body. Collagen is the most important component of the extracellular matrix.`,
                list: [
                  {
                    title: `1886`,
                    desc: `Construction and production of gelatin`
                  },
                  {
                    title: `1906`,
                    desc: `Production of edible gelatin`
                  },
                  {
                    title: `1946`,
                    desc: `Rebuilding the factory after World War II`
                  },
                  {
                    title: `1972`,
                    desc: `Producing gelatine from pig skin`
                  },
                  {
                    title: `2004`,
                    desc: `Production of organic gelatin`
                  },
                  {
                    title: `2010`,
                    desc: `Gelatin powder production line`
                  },
                  {
                    title: `2013`,
                    desc: `Implementation of new raw materials factory`
                  }
                ]
              },
              mod2: [ //  胶原蛋白的功效
                {
                  title: ``,
                  img: `https://index.cuican520.com/rtt.png`
                },
                {
                  title: ` ● Repairing the skin —— the collagen content of the dermis in the skin is more than 70%. Dr. Brant, the father of the world's collagen, believes that "the process of aging of the skin is the process of collagen loss." After the age of 25, the collagen begins to lose. At this time, it is necessary to supplement collagen to improve skin looseness, dryness, wrinkles, cracks, orange peel and other problems, to reproduce the skin's youthful and healthy state, and to strengthen the chest, strengthen the hair, and strengthen the nails.`,
                  title2: ` ● Improve joint/s —— Collagen content in joints is more than 60%, collagen improvement joint research has carried out multiple randomized, double-blind experiments in many countries and regions, and found that collagen improves bone joints similarly to VD. With no side effects, the efficiency is up to 80%.`,
                  title3: ` ● Strong bones —— Collagen content in bone organic matter is more than 90%. Collagen forms a network structure that locks calcium and prevents calcium loss. Therefore, the key to calcium supplementation is calcium fixation. Taking collagen can effectively prevent and improve osteoporosis, bone hyperplasia and other problems, enhance bone elasticity and flex resistance, reduce the incidence of fractures, and promote bone healing.`,
                  title4: ` ● Protect eyesight —— prevent and repair false myopia and delay vision loss.`,
                  title5: ` ● Healthy mind and brain —— enhance the elasticity of the blood vessel wall and muscle toughness, and protect the cardiovascular health of the heart and brain.`,
                  title6: ` ● Reduce the pain —— enhance the body's immunity, calm the nerve center, calm the anxiety, nervousness; relieve inflammation, pain and other discomfort in the stomach, joints and other areas.`,
                  img: ``
                }
              ],
              mod3: [ //  市场份额
                {
                  title: `Collagen peptides are food raw materials obtained by enzymatic hydrolysis of collagen.`,
                  title2: `Advantages: natural products; non-genetically modified;
                  Excellent sensory experience;
                  Clear solution;
                  Temperature and acid and alkali resistance;
                  High biological activity;
                  Stimulates the body's own collagen production.`,
                  title3: `Not all collagen is biologically active. Bioactive collagen must stimulate connective tissue cells to increase anabolism. Collagen peptide stimulates the metabolism of human collagen. The average molecular weight is the key to collagen bioactivity.`
                }
              ],
              mod4: [ //  临床研究
                {
                  title: ``,
                  img: `https://index.cuican520.com/lcyj1.png`
                },
                {
                  title: `Collagen peptides with an average molecular weight of 2000 daltons help maintain young skin`,
                  title2: `Bioactive collagen peptides with an average molecular weight of 3000 daltons have an effect on articular cartilage repair`,
                  title3: `Collagen peptides with an average molecular weight of 3,500 daltons can significantly increase bone density`,
                  img: ``
                },
                {
                  title: ``,
                  img: `https://index.cuican520.com/lcyj2.png`
                },
                {
                  title: ``,
                  img: `https://index.cuican520.com/lcyj3.png`
                }
              ]
            }
          }
        ],
        gelatin__title: [`Company and its development`, `The company's main products`, `Market share and international market`, `QC`, `Quality certificates`, `Product information`, `Product packaging`],
        gelatin__titlelist: [
          {
            pro: ['Company and its development', 'The company`s main products', 'Market share and international market', 'QC', 'Quality certificates', 'Product information', 'Product packaging']
          },
          {
            pro: ['Definition of Collagen peptide', 'Collagen peptide efficacy', 'Collagen peptides and their advantages', 'Clinical studies and examples of collagen peptide products']
          }
        ],
        germanybrand: [ //  德国品牌
          {
            id: 0,
            text: 'Watch',
            images: 'https://index.cuican520.com/brand_watch.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'GmbH', //  标题
                imglist: ['https://index.cuican520.com/w1.png', 'https://index.cuican520.com/w2.png', 'https://index.cuican520.com/w3.png'], //  图片列表
                showimg: '', //  展示图片
                desc: 'Montblanc International is a manufacturer of fine pens, watches and accessories from the Richemont Group in Germany. The "White Hexagon Star" trademark is used for identification. Founded in 1906 in Hamburg, Germany by a stationery dealer, an engineer, and a banker, the company was founded under the name of Simplo Filler Pen Company before adopting the Montblanc trademark in 1911. The company was later owned by Dunhill and is now part of the Richemont Group.' //  描述
              },
              {
                id: 2, //  编号
                title: 'Chopard', //  标题
                imglist: ['https://index.cuican520.com/x1.png', 'https://index.cuican520.com/x2.png', 'https://index.cuican520.com/x3.png'], //  图片列表
                showimg: '',
                desc: 'Chopard is a high-end watch and jewellery brand founded in Switzerland in 1860 by Essex-Chopard. Chopard`s product style is craftsmanship and fashion dynamics. The Swiss jewelry watch brand Chopard Watch, which spans more than 140 years of history, has always combined extraordinary creativity with luxurious materials to design a timepiece with superior and novel taste. 2013 Chopin brand Adhering to the rich results of the past, we have researched a variety of complex watch models and launched more diversified creations. Among them, the style named after the founder`s English abbreviation uses the movement developed by the company in 2007. The table design is simple, full of character, full of strong lines.' //  描述
              },
              {
                id: 3, //  编号
                title: 'Cartier', //  标题
                imglist: [
                  'https://index.cuican520.com/k1.png',
                  'https://index.cuican520.com/k2.png',
                  'https://index.cuican520.com/k3.png'], //  图片列表
                showimg: '',
                desc: 'Cartier is a French watch and jewellery manufacturer founded in 1847 by Louis-François Cartier at Rue Montorgueil, Paris. It is now a subsidiary of Compagnie Financière Richemont SA. In 1874, his son, Yafa Cartier, inherited his management rights, and his grandsons Louis Cartier, Pierre Cartier and Jess Cartier developed it into a world famous brand. The world`s first modern watch with both decoration and functionality was designed by Cartier. Cartier incorporates the concepts and techniques of jewellery in the design of the watch, making the watch look gorgeous and distinguished.' //  描述
              },
              {
                id: 4, //  编号
                title: 'Vacheron Constantin', //  标题
                imglist: [
                  'https://index.cuican520.com/j1.png',
                  'https://index.cuican520.com/j2.png',
                  'https://index.cuican520.com/j3.png'], //  图片列表
                showimg: '',
                desc: 'Vacheron Constantin is one of the  most famous watch brands around the world. Founded in 1755 in Geneva, Switzerland, Vacheron Constantin is the  oldest watch manufacturer and one of the most famous watch manufacturers. Vacheron Constantin inherits the essence of traditional Swiss watchmaking, has not been interrupted, but also innovated many watchmaking techniques, and made great contributions to the watchmaking industry. With more than two hundred years of watchmaking history, Vacheron Constantin is the  oldest and longest-lasting brand-name watch. Its cross mark on the dial like the Swiss national emblem is already a symbol of taste, status and wealth. Today, Vacheron Constantin is synonymous with "time", and it is an irreplaceable wrist art in the eyes of the watchmakers.rs. Vacheron Constantin inherits the essence of traditional Swiss watchmaking, has not been interrupted, but also innovated many watchmaking techniques, and made great contributions to the watchmaking industry. With more than two hundred years of watchmaking history, Vacheron Constantin is the  oldest and longest-lasting brand-name watch. Its cross mark on the dial like the Swiss national emblem is already a symbol of taste, status and wealth. Today, Vacheron Constantin is synonymous with "time", and it is an irreplaceable wrist art in the eyes of the watchmakers.' //  描述
              },
              {
                id: 5, //  编号
                title: 'Patek Philippe', //  标题
                imglist: [
                  'https://index.cuican520.com/b1.png',
                  'https://index.cuican520.com/b2.png',
                  'https://index.cuican520.com/b3.png'], //  图片列表
                showimg: '',
                desc: 'Patek Philippe is a famous Swiss watch brand that began in 1839 and is the world`s top ten watch. It is one of the only remaining independent watchmakers in Switzerland, producing it from start to finish. Patek Philippe enjoys a comprehensive freedom of innovation in the overall process of design, production and assembly, creating a masterpiece of global watchmaking that is praised by experts from around the world, and is committed to the brand founders Antoine Norbert de Patek and Mr. Julie ( Jean-Adrien Philippe`s vision of excellence, with its extraordinary professional skills and adhering to the tradition of quality innovation, Patek Philippe has more than 80 technical patents. Patek Philippe is "the blue blood aristocrat in the watch."' //  描述
              },
              {
                id: 6, //  编号
                title: 'IWC', //  标题
                imglist: [
                  'https://index.cuican520.com/i1.png',
                  'https://index.cuican520.com/i2.png',
                  'https://index.cuican520.com/i3.png'], //  图片列表
                showimg: '',
                desc: 'Founded in 1868, IWC is ranked 11th in the world, second only to Rolex. Its watch factory is located in Schaffhausen, Switzerland. The company has developed a watchmaking process, and its design and technology have always been leading in the same industry, creating a timeless classic. The extraordinary technology and exquisite craftsmanship of the country is not only a symbol of Schaffhausen`s excellent and pure watchmaking craft, but also reflects the consistent adherence of the country to its purpose. With its precise technical performance and outstanding design, IWC has a pivotal position in the world of watchmaking. Wan Guo is known as the “high-end watch engineer”. The classic style and ingenious design are elegant and exquisite, and the operation is extremely simple. Since 1868, every watch produced by IWC has been recorded in the watch`s factory record book, and important spare parts are stored in high cabinets, so watchmakers in the world can even overhaul the oldest watch movements. . Therefore, each of the nations is a heirloom for future generations.' //  描述
              },
              {
                id: 7, //  编号
                title: 'LONGINES', //  标题
                imglist: [
                  'https://index.cuican520.com/l1.png',
                  'https://index.cuican520.com/l2.png',
                  'https://index.cuican520.com/l3.png'], //  图片列表
                showimg: '',
                desc: 'LONGINES is a company founded by Ernest Francilin in St. Amir, Switzerland. Its origins can be traced back to the 1930s, when Longines also has the oldest registered trademark (a hourglass with wings). Longines belongs to the Swiss Swatch Group. Longines is famous for its "flying home" watch and is one of the world`s top waterproof watches. With a history of more than 100 years, Longines has always adhered to the philosophy of working with the best quality, constantly striving to innovate in time craftsmanship, and Longines has become synonymous with precision!' //  描述
              },
              {
                id: 8, //  编号
                title: 'Tissot', //  标题
                imglist: [
                  'https://index.cuican520.com/t1.png',
                  'https://index.cuican520.com/t2.png',
                  'https://index.cuican520.com/t3.png'], //  图片列表
                showimg: '',
                desc: 'Tissot was founded in the small town of Le Locle in the Jura mountains of Switzerland, and its headquarters is still there. The "+" in the Tissot logo is a symbol of Swiss quality, demonstrating the brand`s relentless quality that has been pursued since 1853. Tissot watches are sold in more than 160 countries. They are made of special materials and are of pure quality. The price is close to the people, with advanced features and meticulous design. Tissot has always adhered to the brand spirit of “extraordinary creativity, stemming from tradition”. Tissot`s high-end quality has been repeatedly recognized. The brand has served as the official timekeeper and partner for numerous sporting events, including: the National Basketball Association (NBA) and the International Basketball Federation (FIBA) in basketball; the Tour de France in the bicycle field and the UCI World Cycling Championship; motorcycles The World Motorcycle Championships (MotoGPTM) and the International Motorcycle Federation (FIM) World Superbike Championships; and the RBS Six Nations Football Game in the Rugby Field, the French Football TOP14 League, the European Football Champions Cup and the Challenge Cup. The brand is also the official timekeeper for the Fencing and Ice Hockey World Championships and the American Football League (AFL). ' //  描述
              },
              {
                id: 9, //  编号
                title: 'Jaeger-LeCoultre', //  标题
                imglist: [
                  'https://index.cuican520.com/jj1.png',
                  'https://index.cuican520.com/jj2.png',
                  'https://index.cuican520.com/jj3.png'], //  图片列表
                showimg: '',
                desc: 'Jaeger-LeCoultre is a luxury watch manufacturer based in Le Sentier, Switzerland. Since its founding in the Vallée de Joux in Switzerland in 1833, it has become a watchmaking brand in watchmaking history. As a pioneer in the top watchmaking industry, Jaeger-LeCoultre not only combines precision timing technology with exquisite artistic talent, but also contributes to the development of the entire watchmaking industry. As the spokesperson of the fine watch, Jaeger-LeCoultre has a total of 40 full-time divisions and 20 cutting-edge technologies, taking into account each production detail, following the exquisite traditional watchmaking process and constantly pursuing technological innovation, and has devoted every time to the manufacture of each watch. The enthusiasm of the development of outstanding watches. Today, Jaeger-LeCoultre continues to surpass itself and create a total of more than 1,200 movements, and enjoys 398 registered patents, from the world`s smallest style to multi-functional and complex watches, as well as ultra-thin Watches and Atmos perpetual motion air clocks, each masterpiece, inherits the 178-year-old watchmaking process of Jaeger-LeCoultre, and is a model in the fine watchmaking industry.' //  描述
              },
              {
                id: 10, //  编号
                title: 'PIAGET', //  标题
                imglist: [
                  'https://index.cuican520.com/bj1.png',
                  'https://index.cuican520.com/bj2.png',
                  'https://index.cuican520.com/bj3.png'], //  图片列表
                showimg: '',
                desc: 'In 1874, the Earl of PIAGET was founded by the 19-year-old Georges Edouard Piaget, and the Piaget of PIAGET still inherits and pioneers the history of the Piaget. Since its birth in 1874, Piaget has been adhering to the brand spirit of “Always doing better than the requirements”, integrating craftsmanship and infinite creativity into each piece, while giving priority to the development of creativity and the pursuit of detail, the watch and The craftsmanship of the jewelry is completely integrated. At the beginning of the establishment, Piaget focused on the design and production of watch movements.' //  描述
              }
            ]
          },
          {
            id: 1,
            text: 'Jewelry',
            images: 'https://index.cuican520.com/brand_2.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'Cartier', //  标题
                imglist: [
                  'https://index.cuican520.com/zbk1.png',
                  'https://index.cuican520.com/zbk2.png',
                  'https://index.cuican520.com/zbk3.png'], //  图片列表
                showimg: '',
                desc: `Cartier is a French watch and jewellery manufacturer founded in 1847 by Louis-François Cartier at Rue Montorgueil, Paris. Today Cartier designs, whether high-end jewelry or contemporary jewellery product lines, such as the Caresser d'Orchidées par Cartier collection, all define Maison's values  on unique know-how, style and expertise. Cartier's gorgeous classical style makes his necklaces, bracelets, watches, rings and earrings popular with the upper class. In addition to the classic three-ring design, animals such as elephants and birds in nature are also themes that often appear in Cartier jewelry. Cartier is not only a symbol of the upper class, but also a classic brand that witnesses eternal love. Whether it is a person with a certain status, or a young couple, Cartier always conveys irresistible love magic. The characteristics of the times combined with traditional craftsmanship Shen Yun is the highest level that Cartier's fine jewellery collection has been pursuing. In the smooth lines and clear colors, Cartier plays the true meaning of beauty - beauty lies in simplicity, not in complexity, in harmony, not in conflict.` //  描述
              },
              {
                id: 2, //  编号
                title: `PIAGET`, //  标题
                imglist: [
                  'https://index.cuican520.com/zbbj1.png',
                  'https://index.cuican520.com/zbbj2.png',
                  'https://index.cuican520.com/zbbj3.png'], //  图片列表
                showimg: '',
                desc: 'In 1874, the Earl of PIAGET was founded by the 19-year-old Georges Edouard Piaget, and the Piaget of PIAGET still inherits and pioneers the history of the Piaget. Since its birth in 1874, Piaget has been adhering to the brand spirit of “Always doing better than the requirements”, integrating craftsmanship and infinite creativity into each piece, while giving priority to the development of creativity and the pursuit of detail, the watch and The craftsmanship of the jewelry is completely integrated. For the Earl, creativity is as important as precious metals. The brand continues to innovate in its design studios, consolidating the status of extraordinary watches and jewelers. There, Piaget Designers exerted free creativity and boldness, and brand new interpretations of the brand`s iconic elements.' //  描述
              },
              {
                id: 3, //  编号
                title: 'Chopard', //  标题
                imglist: [
                  'https://index.cuican520.com/zbx1.png',
                  'https://index.cuican520.com/zbx2.png',
                  'https://index.cuican520.com/zbx3.png'], //  图片列表
                showimg: '',
                desc: 'Chopard (English name Chopard) is a high-end watch and jewellery brand founded in 1860 by Lucy Cleopatra in Switzerland. Chopard`s product style is craftsmanship and fashion dynamics. The Swiss jewelry watch brand Chopard Watch, which spans more than 140 years of history, has always combined extraordinary creativity with luxurious materials to design a timepiece with superior and novel taste. 2013 Chopin brand Adhering to the rich results of the past, we have researched a variety of complex watch models and launched more diversified creations. Among them, the style named after the founder`s English abbreviation uses the movement developed by the company in 2007. The table design is simple, full of character, full of strong lines.' //  描述
              }
            ]
          },
          {
            id: 2,
            text: 'Necessary',
            images: 'https://index.cuican520.com/brand_3.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'Herbacin', //  标题
                imglist: [
                  'https://index.cuican520.com/rhbq1.png',
                  'https://index.cuican520.com/rhbq2.png',
                  'https://index.cuican520.com/rhbq3.png'], //  图片列表
                showimg: '',
                desc: `Herbain's raw materials are selected from high-quality plant extracts, followed by a rigorous German manufacturing process to produce quality hand care, cracked skin care, facial care, botanical hair care, body care product. Formulated with German chamomile extract for immediate skin and hair treatment He Benqing's German chamomile products have been tested by German dermatology medical ingredients and are all developed and manufactured in Germany. Meet the stringent German production standards and results confirmed. One of the 100 most worthwhile cosmetics by Hong Kong magazine has been tested by Hong Kong yahoo website. The highest score of five stars is fragrant and moisturized. After use, it is refreshing and not greasy. It is a common visitor to Japanese magazines!` //  描述
              },
              {
                id: 2, //  编号
                title: 'Braun', //  标题
                imglist: [
                  'https://index.cuican520.com/rbl1.png',
                  'https://index.cuican520.com/rbl2.png',
                  'https://index.cuican520.com/rbl3.png'], //  图片列表
                showimg: '',
                desc: `Braun products are divided into six categories: electric razors, female shavers, hair products, kitchen appliances, steam irons, one-second thermometers. The goal pursued by Braun in Germany has always been clear, simple and balanced lines.
                Braun's mission extends to be the unique Braun Design philosophy: innovation, quality, practicality, beauty, simplicity, detail, classics, and environmental protection.
                For decades, Braun has become a global home appliance giant with more than 200 products in 10 categories, with its persistent pursuit of quality, attention to every detail, genius creativity and user-friendly design.` //  描述
              },
              {
                id: 3, //  编号
                title: 'Balla', //  标题
                imglist: [
                  'https://index.cuican520.com/rbly1.png',
                  'https://index.cuican520.com/rbly2.png',
                  'https://index.cuican520.com/rbly3.png'], //  图片列表
                showimg: '',
                desc: `Founded in 1973 in Karlsruhe, Germany, it currently has 869 chain markets in Germany and 851 chain stores in other European countries. German dm chain stores are really everywhere in every city in Germany.` //  描述
              },
              {
                id: 4, //  编号
                title: 'Dr.Hauschka ', //  标题
                imglist: [
                  'https://index.cuican520.com/rdgsj1.png',
                  'https://index.cuican520.com/rdgsj2.png',
                  'https://index.cuican520.com/rdgsj3.png'], //  图片列表
                showimg: '',
                desc: `Originated in 1929, Dr.Hauschka has a more basic and respectful approach to the skin, taking every step of the material used on the skin seriously and spending a lot of time, and launching a series of holistic products, also It is the product that you are currently seeing. The formula has not changed so far, and the word of mouth is as good as it was when it was launched.
                Nowadays, Dr.Hauschka has always maintained a leading position in Europe. Not only has the evaluation of "BEST BUY" been maintained in the evaluation of OKO, but also the magazines of major health have mentioned that the cultivation of plants has already begun. A brand that is different." In the organic evaluation, Dr.Hauschka is also a frequent visitor to the top three. Among the commodities, the most well-known rhythm is almost out of stock. Because of the fixed speed of its manufacture, it cannot be supplied in an unlimited amount and often needs to wait.` //  描述
              },
              {
                id: 5, //  编号
                title: 'MANHATTAN', //  标题
                imglist: [
                  'https://index.cuican520.com/rmhd1.png',
                  'https://index.cuican520.com/rmhd2.png',
                  ''], //  图片列表
                showimg: 'https://index.cuican520.com/rmhd1.png',
                showimg2: 'https://index.cuican520.com/rmhd2.png',
                desc: `“MANHATTAN make-up is produced by Dr. Scheller Cosmetics GmbH, Germany. The company's headquarters is located in Munich/Stuttgart, Germany's most developed region, and has a history of 60 years. MANHATTAN series of makeup parts are divided into five categories: lip, eye, nail polish, facial makeup and accessories. It provides a complete collection of all make-up products.` //  描述
              },
              {
                id: 6, //  编号
                title: 'Terry', //  标题
                imglist: [
                  'https://index.cuican520.com/rtrm1.png',
                  'https://index.cuican520.com/rtrm2.png',
                  'https://index.cuican520.com/rtrm3.png'], //  图片列表
                showimg: 'https://index.cuican520.com/rtrm1.png',
                desc: `Henkel has a history of nearly 140 years and operates in Europe, North America, Asia Pacific and Latin America. It produces and operates more than 10,000 kinds of civil and industrial products in nearly 75 countries. Terry is a well-known oral care brand of Henkel. Many of Henkel's brands are market-leading and enjoy a good reputation, such as Baoying, Schwarzkopf, and Loctite.` //  描述
              },
              {
                id: 7, //  编号
                title: 'Biotulin', //  标题
                imglist: [
                  'https://index.cuican520.com/rbotl1.png',
                  'https://index.cuican520.com/rbotl2.png',
                  'https://index.cuican520.com/rbotl3.png'], //  图片列表
                showimg: '',
                desc: `Since its launch in 2014, she has quickly become the new favorite of the current European and American celebrities, and the world-renowned media has been rushing to report; she has been able to sweep the French Champs Elysées, which has always been known for fashion, and has won countless fashion people. awesome.
                She is the Biotulin natural wrinkle hydrating cream. It is the famous British Kate Princess, the first lady of the United States, Michelle, the Queen of Spain, the chief designer of Karl Lager & Chanel, Madonna, Leonardo and many other famous people. A product that has always been praised.
                Biotulin Bio wrinkle natural wrinkle hydrating cream shocked the world for the first time. It was the British Princess Kate who made it easy for the media to meet after the birth of the little Princess Charlotte in 2015. After a week, the European media questioned the birth of King Kate. The authenticity of the little princess. The reason for questioning is because the public thinks that normal people can not recover such good color and skin in just a few hours after birth. In this regard, Kate's nursing team revealed through an official statement that it is because King Kate has been using Biotulin natural wrinkle hydrating cream.
                What is the magic of this hydrating cream? Can King Kate be so favored and have such a powerful effect? Biotulin 1 hour magical effect, instant experience of wrinkle and eye bags; 24-hour high-efficiency continuous anti-wrinkle moisturizing, so that the skin as a whole water-lubricated bomb; 30 days skin is improved in essence, and the effect of anti-age effect is presented. This is why Biotulin is so popular.
                The emergence of Biotulin, which allows people to say goodbye to botulinum toxin, which is made of geranium, citronella, hyaluronic acid and gold buttons, removes excess muscle from the skin through natural ingredients, thereby eliminating wrinkles. the goal of. In addition, her natural moisturizing factor can perfectly consolidate the skin's water-locking function, ensuring that the skin is smooth and smooth for 24 hours, leaving the skin radiant forever.`
              },
              {
                id: 8, //  编号
                title: 'Schaebens ', //  标题
                imglist: [
                  'https://index.cuican520.com/rxbs1.png',
                  'https://index.cuican520.com/rxbs2.png',
                  'https://index.cuican520.com/rxbs3.png'], //  图片列表
                showimg: '',
                desc: 'Haus Schaebens is a medium-sized family business with a long history. The company is headquartered in Frechen, near Cologne. The company has dedicated and motivated employees, a positive and cooperative team spirit, and is committed to the customer`s satisfactory business philosophy. The company operates special products in the fields of cosmetics, pharmaceuticals, and health care, C&C and consumer markets, and various sales channels for SB hypermarkets. Professional and efficient business philosophy, the product range continues to expand and improve. For future flexibility and innovation, Haus Schaebens achieved high sales growth. Development far exceeds the industry average. Haus Schaebens` products are dedicated to your health and beauty and to improving the quality of your life.' //  描述
              }
            ]
          },
          {
            id: 3,
            text: 'Health care products',
            images: 'https://index.cuican520.com/brand_4.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'Doppelherz', //  标题
                imglist: [
                  'https://index.cuican520.com/bsx1.png',
                  'https://index.cuican520.com/bsx2.png',
                  ''], //  图片列表
                showimg: '',
                desc: `Doppelherz: consists of two hearts, is a famous German health care product brand, the service concept is "to put the health of customers in our hearts", is committed to the development and development of high-quality health products from pure natural raw materials, deeply in Germany and Europe Consumers trust. Germany has the world's most stringent drug testing standards and the most regulated pharmaceutical market. The products are famous for their pure quality and remarkable efficacy. The drug testing process is much stricter than the loose health products of the United States and Canada.
                In 1919, the German chemist Josef Peter Hennes extracted the active ingredients from herbs and other natural plants to make Doppelherz's well-known herbal energy conditioning solution (for cardiac function conditioning), and the name "Doppelherz" was derived.
                Up to now, "Doppelherz" has become a pioneer in the health care products market. Its products are no longer limited to heart health, but extend to all areas of the needs.
                All products produced by Doppelherz are high-efficiency health care products or natural health products, and contain no side effects. At present, a considerable number of high-end consumer groups in China also have high recognition. Up to now, "Doppelherz" has become a pioneer in the health care products market.` //  描述
              },
              {
                id: 2, //  编号
                title: 'Mucosolvan', //  标题
                imglist: [
                  'https://index.cuican520.com/bmst1.png',
                  'https://index.cuican520.com/bmst2.png',
                  ''], //  图片列表
                showimg: '',
                desc: `Mucosolvan (amyl bromide oral solution / tablet / sustained release capsule), non-prescription drugs, suitable for sputum viscous and not easy to cough. Available in three dosage forms, including oral solutions/tablets and extended release capsules, suitable for different populations.
                The active ingredient of mucosolvan is "ambroxol hydrochloride", which is referred to as "ambroxol". The precursor of such drugs, bromhexine, is extracted from the saponin. Abalone is derived from an Asian plant and has been shown to be very effective in removing sputum, loosening and thinning sputum accumulated in the respiratory tract, preventing new mucus from being produced, thereby improving the cleansing function of the respiratory tract. More specifically, it can increase the secretion of mucous membranes in the respiratory mucosa, reduce the secretion of mucous glands, thereby reducing the viscosity of sputum, promoting the secretion of alveolar surfactant, increasing the movement of bronchial ciliary, making sputum easy to cough up, and alleviating the symptoms of cough. Efficacy.
                As a peony, Mucosolvan is recommended by the "Children's Respiratory Safety Medicine Expert Consensus _ Cold and Antipyretic Drugs", "Expert Consensus for the Diagnosis and Treatment of Common Colds" and "Guidelines for Diagnosis and Treatment of Cough".` //  描述
              },
              {
                id: 3, //  编号
                title: 'Bayer', //  标题
                imglist: [
                  'https://index.cuican520.com/bbe1.png',
                  'https://index.cuican520.com/bbe2.png',
                  'https://index.cuican520.com/bbe3.png'], //  图片列表
                showimg: '',
                desc: `Bayer is one of the world's best-known Fortune 500 companies. Headquartered in Leverkusen, Germany, the company has 750 manufacturing facilities in 200 locations on six continents; it has 120,000 employees and 350 branches, almost all over the world. Polymers, medical and health care, chemicals and agriculture are the four pillar industries of the company. With more than 10,000 product categories, the company is the largest industrial group in Germany. The company's aspirin, known as the "medicine of the century", has also created the "devil's masterpiece", which is heroin.` //  描述
              }
            ]
          },
          {
            id: 4,
            text: 'Luggage',
            images: 'https://index.cuican520.com/brand_5.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'RIMOWA', //  标题
                imglist: [
                  'https://index.cuican520.com/xrmg1.png',
                  'https://index.cuican520.com/xrmg2.png',
                  'https://index.cuican520.com/xrmg3.png'], //  图片列表
                showimg: 'https://index.cuican520.com/xrmg1.png',
                desc: `Among the many suitcase brands in the world, Rimowa is unique in its consistent use of aluminum-magnesium alloy products, so that Rimowa has become synonymous with aluminum suitcases, and it is the stubbornness and persistence of this “German style”. A brilliant legend of Rimowa. So far, Rimowa has appeared in countless Hollywood blockbusters, even attracting the attention of Porsche and Lufthansa, and inviting Rimowa to design them exclusively.
                This German brand with a grooved design and a history of more than a century has become a necessary equipment for successful people, and Rimowa has been regarded as synonymous with “fashion + practicality”.
                It is worth mentioning that all Rimowa aluminum-magnesium alloy suitcases still maintain the tradition of hand-made, and in order to ensure the quality, Rimowa products are only manufactured in Europe, and there is no overseas branch - have to say, compared In today's rapid development of the industrialized industry, such a heavy "quality" and light "quantity" approach is really commendable. ` //  描述
              },
              {
                id: 2, //  编号
                title: 'TUMI', //  标题
                imglist: [
                  'https://index.cuican520.com/xtumi1.png',
                  'https://index.cuican520.com/xtumi2.png',
                  'https://index.cuican520.com/xtumi3.png'], //  图片列表
                showimg: '',
                desc: `TUMI is a brand that was launched in the United States in 1975. The main products are mainly travel bags and business bags. The bag made of nylon material is very wear-resistant. Its life span is far longer than other brands. It has reached the military standard and is beyond the reach of other similar products. It also establishes Tumi in The leading position of the market.
                TUMI, which has always been committed to creating high-quality business and travel accessories, has launched a wide range of backpacks, product design, continuous technological innovation, superior raw material quality and superb manufacturing processes, all of which have created TUMI's extraordinary products. . TUMI backpack is good, you can know the details. From small to solid steel screws to TUMI's special anti-wear FXTTM ballistic nylon materials, TUMI is committed to excellence.` //  描述
              },
              {
                id: 3, //  编号
                title: 'Samsonite', //  标题
                imglist: [
                  'https://index.cuican520.com/xxxl1.png',
                  'https://index.cuican520.com/xxxl2.png',
                  'https://index.cuican520.com/xxxl3.png'], //  图片列表
                showimg: '',
                desc: 'The Samsonite brand was founded in the United States in 1910 and has a history of more than 100 years. At the time, Mr. Jesse Schwart wanted to give the new suitcase an alias that would symbolize the firmness and durability of the product. Among the favorite heroes, Mr. Schwart chose Samson, the strong man in the Bible, to symbolize the characteristics of the goods. The company pursues the business philosophy of "treating others as oneself" and always takes customer satisfaction as its goal. Adhering to the "people-oriented" design philosophy, strict quality testing, its products become a model of the perfect combination of art and technology. As an expert in the field of travel goods, it continues to create a unique, durable, stylish and comfortable luggage product with the image of the world leader and innovator.' //  描述
              }
            ]
          },
          {
            id: 5,
            text: 'Kitchenware',
            images: 'https://index.cuican520.com/brand_6.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'ZWILLING ', //  标题
                imglist: [
                  '',
                  '',
                  ''], //  图片列表
                showimg: 'https://index.cuican520.com/cslr1.png',
                showimg2: 'https://index.cuican520.com/cslr2.png',
                desc: `ZWILLING was founded on June 13, 1731, when the Gemini Gemini constellation, the "two people" logo of Zwilling was born in Solingen, a small town on the Rhine in Germany. Since there was no trademark office at the time, the Zwilling logo was announced in a local church. This is one of the oldest trademarks in the history of mankind. It is also the embodiment of rare qualities and immortal legends. It has a mysterious steel formula and a world-wide ice-forging process of -200 degrees Celsius. It is a perfect quality of life and perfection. The classic symbol of the spirit.
                German pots have natural antibacterial and high temperature resistance, which can save energy and protect the environment, and the heat conduction effect is excellent. People say, "With this kind of German pot, a candle can make a delicious meal." A pot made by the German can be used for 100 years, so many Germans use the pot that the grandmother passed down. For the Germans, any kitchen utensils only need to be bought once in a lifetime. You don't need to buy a second time, because you will not use it for a lifetime. The pot used in the soup produced by the Germans is completely cast in steel. It is so heavy that even the men have no point at all. The inside of the lid has a strange pattern. Someone once asked the manufacturer: "What are these patterns?" Said: "When it is covered, the water vapor can naturally circulate up and down, it is not easy to burn. This is a technology." German pots, covered with a tight seam, said three minutes to open the pot for three minutes, this can be You save a lot of gas bills.` //  描述
              },
              {
                id: 2, //  编号
                title: 'WMF', //  标题
                imglist: [
                  'https://index.cuican520.com/cwmf1.png',
                  'https://index.cuican520.com/cwmf2.png',
                  'https://index.cuican520.com/cwmf3.png'], //  图片列表
                showimg: '',
                desc: `1In 880, the sales-oriented company Straub merged with a technology-leading rival Ritter. The company is named: Wurttembergische Metallwaren Fabrik AG referred to as WMF.
                The Art Nouveau movement brought a modern conception of product design art. Since 1895, WMF has applied art such as curves and asymmetrical shapes to product design, realizing the combination of traditional and modern art.
                Today, WMF has more than 190 subsidiaries in various cities in Germany and major European countries in Switzerland, Austria and France. It has established sales subsidiaries in the United States, Japan and China, and its products are exported to more than 90 countries.` //  描述
              },
              {
                id: 3, //  编号
                title: 'Fissler', //  标题
                imglist: [
                  'https://index.cuican520.com/cfsl1.png',
                  'https://index.cuican520.com/cfsl2.png',
                  'https://index.cuican520.com/cfsl3.png'], //  图片列表
                showimg: '',
                desc: `All products of Fissler Germany have passed European certification standards. With its superior quality and simple and elegant design, Fissler has many users and collectors around the world.
                German Fissler is one of the oldest and oldest pot brands in the world. The history of Fissler is the chronicle of the development of kitchen utensils in the world. Almost all about the historical progress of kitchen utensils, it is inseparable from the invention and technological innovation of Fissler.` //  描述
              },
              {
                id: 4, //  编号
                title: 'BRITA ', //  标题
                imglist: [
                  'https://index.cuican520.com/cbrd1.png',
                  'https://index.cuican520.com/cbrd2.png',
                  'https://index.cuican520.com/cbrd3.png'], //  图片列表
                showimg: 'https://index.cuican520.com/cbrd1.png',
                desc: `BRITA, a water filtration expert from Germany, improves the water quality and effectively reduces chlorine, scale and heavy metals. Born in 1966, it is sold in more than 60 countries around the world, with material safety and food quality certification from European authorities!
                Company vision: We will change the way people drink water and ensure sustainable development!` //  描述
              }
            ]
          },
          {
            id: 6,
            text: 'Baby Products',
            images: 'https://index.cuican520.com/brand_7.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'Penaten', //  标题
                imglist: [
                  'https://index.cuican520.com/mbnt1.png',
                  'https://index.cuican520.com/mbnt2.png',
                  'https://index.cuican520.com/mbnt3.png'], //  图片列表
                showimg: '',
                desc: `One of the three giants of German baby skin care brands -- Penaten
                In 1904, MaxRiese invented this Penaten Creme cream for the care of baby's delicate skin, and registered his invention in Berlin on September 14 of the same year. At the same time, the Penaten company was established in Rhoendorf, near the city of Bonn, Germany.
                In 1929, a total of 436,000 Penaten Creams (PenatenCreme) were sold, proving the success of this product. In 1939, 10 years later, sales reached an astonishing 6,019,000.
                During World War II, the Riese heirs placed Penaten's production lines in separate locations and re-started the production of nursing creams in 1945 after the war, while rebuilding the company.
                Since 1951, Penaten has begun to bring a variety of baby oils, skin care soap powders and other products to the market while ensuring the classic product-care cream, and has succeeded in forming a series of baby care products. `//  描述
              },
              {
                id: 2, //  编号
                title: 'WELEDA', //  标题
                imglist: [
                  'https://index.cuican520.com/mwld1.png',
                  'https://index.cuican520.com/mwld2.png',
                  'https://index.cuican520.com/mwld3.png'], //  图片列表
                showimg: 'https://index.cuican520.com/mwld1.png',
                desc: `One of the baby skin care giants.
                WELEDA, headquartered in southern Germany, is the founder of Human Intelligence, Dr. Rudolf Steiner (1861-1925 Australian). The brand founded in Switzerland in 1921 is a company dedicated to the acquisition and consolidation of human health in more than 40 countries around the world. From the very beginning, it has unified human and nature as the core spirit of the company. Weleda's development, production and operation are in the fields of medicines, nutritional supplements and body care products. Over the years, WELEDA has worked closely with universities and national research institutes for a long time. It has its own laboratory and the largest flower and plantation plant for skin care products in Europe. It guarantees the purity and sufficiency of the supply and was selected as the best company in Germany in 2004. One.` //  描述
              },
              {
                id: 3, //  编号
                title: 'Aptamil', //  标题
                imglist: [
                  'https://index.cuican520.com/matm1.png',
                  'https://index.cuican520.com/matm2.png',
                  'https://index.cuican520.com/matm3.png'], //  图片列表
                showimg: '',
                desc: `Aptamil is Germany's leading high-end milk powder brand, the first in the German market, and one of the best-selling milk powders in Europe.
                Aptamil milk powder is produced in Germany and is a brand of the German Milupa Group. The latter is acquired by Danone Group. In 2007, Danone acquired Royal Numico (Nudexia Holder) to merge its infant nutrition and medical nutrition internally. Aptamil and Nutrilon, Karicare three milk powder brands are owned by New Zealand.` //  描述
              },
              {
                id: 4, //  编号
                title: 'HiPP', //  标题
                imglist: [
                  'https://index.cuican520.com/mxb1.png',
                  'https://index.cuican520.com/mxb2.png',
                  ''], //  图片列表
                showimg: '',
                desc: `HiPP was founded by JOSEF HIPP in 1899 and has a history of 110 years. It involves many fields such as food, supplies and toys for mothers and children. As early as 1956, the HiPP operator became a pioneer in the global natural bio-food, which contained no gluten protein (Gluten Free. It Gesetz). They began experimenting with growing fruits and vegetables on farms without chemical fertilizers and stocking them. HiPP has its own quality natural farmers. All products are subject to strict quality control by German experts. Different from the general commercial products, in order to satisfy consumers' taste preferences and mistakes, the more nutrients are more fascinating to the baby, the addition of artificial flavors and chemical nutrients, which will cause the baby's kidney and gastrointestinal burden.` //  描述
              }
            ]
          },
          {
            id: 7,
            text: 'Stationery',
            images: 'https://index.cuican520.com/brand_8.png',
            path: 'watch',
            children: [
              {
                id: 1, //  编号
                title: 'LAMY', //  标题
                imglist: [
                  'https://index.cuican520.com/wLAMY1.png',
                  'https://index.cuican520.com/wLAMY2.png',
                  'https://index.cuican520.com/wLAMY3.png'], //  图片列表
                showimg: '',
                hasstyle: `position: absolute;
                width: 272px;
                height: 272px;
                right: 0;`,
                desc: `Founded by Heidelberg in 1930 by C. Joseph, LAMY is an independent, family-owned company. The brand of LAMY has been established since 1952. In the first year of its business, the LAMY 27 ink pen series has been launched, which fully demonstrates the company's innovative and sensitive touch.
                LAMY produces more than 6 million writing instruments per year, and its turnover exceeds 50 million Euros per year. Today, LAMY is not only a giant in the German writing instrument market, but also an excellent German design brand of the famous international company.
                LAMY also attaches great importance to sustainable production and insists on completing each process in Germany. LAMY's products have successfully established a model of Made in Germany quality logo – who can afford such a reputation besides LAMY?
                LAMY marks the design of quality, creativity and fashion, and upholds the consistent commitment of the LAMY brand: supreme design and unremitting, writing perfection.
                LAMY writing tools have an extraordinary charm, thanks to their superior technology and fashion taste.
                In LAMY's advertising, company owners tell the meaning of LAMY to each other. They are not a general generation, but the central soul of LAMY, reflecting the philosophy that LAMY insists. They are both independent men and women of the era and have their own legendary story.` //  描述
              }
            ]
          }
        ],
        mybrand: [ //  自主品牌
          {
            id: 5,
            text: 'Strahlend',
            images: 'https://index.cuican520.com/zzpp1.png',
            path: 'branddetail'
          }
        ],
        branddetail: [
          {
            title: `Wound protecting & anti-acne cream`,
            desc: `Description of Product Performance: Anti-acne cream could wipe out the keratinocyte & Brightening，and Six peptide -9 was used as the main active component`,
            desc2: `1.Increase the synthesis of collagen;2.Promote the formation and reinforcement of DEJ (epidermal dermal connective tissue)；3.Promote the differentiation and maturation of epidermal cells;4.Have good effect on anti-acne.Added Nicotinamide, Beta-glucan, Lecithin to repair damaged cells.Make skin appear more supple and smooth`,
            desc3: `Recommended use: Apply to the skin surface after cleansing every morning and evening.`
          },
          {
            title: `Marine acne-fighting cream`,
            desc: `Description of Product Performance: Contain pure marine plant extract，transient penetration，shrinking acne and acne-fighting，make skin smooth and younger.`,
            desc2: `1.β-glucan could remove free radicals，repair damaged cells，control and reduce the release of histamine，anti-anaphylaxis; 2.Pores can be opened by Lecithin to scars-removing rapidly;3.Lasting effect on wound，have obvious improvement on discomfort;4.Conditioning acne skin，remove acne efficiently;4.Non-pigment, non-flavor, non-parabens, non- mineral oil, non-alcohol.`,
            desc3: `Recommended use: After cleansing the skin, apply it on your fingers or cotton balls, gently spread on the top of the acne, evenly covered.`
          },
          {
            title: `Lush vitality emulsion`,
            desc: `Description of Product Performance: Strahlend’s plant-beautifying skincare is developed by the top skincare experts and Chinese herbal medicine researchers.Slogan：“Brightening，ruddy and fair，youthfulness”.After thousands of trails，we adopt non- emulsifier system which added glucan made from marine.. The secret is made up of glucan, lecithin, linseed oil, nicotinamide, etc.`,
            desc2: `Recommended use: Use at night before going to bed, evenly apply the face, and gently press the sputum until the skin is completely absorbed.`
          },
          {
            title: `Peptides refreshing toner`,
            desc: `Description of Product Performance: The composition of “Peptides refreshing toner ”is contain Beta-glucan, six peptide -9, palmitic acid, the peptide, the peptide -4, the palm of the palm, the three peptide, -1, the palm, the peptide, the peptide -7, nicotinamide, etc.Be aimed at the dull skin, chloasma, pigmentation and other skin problems, refreshing your skin.Long-term apply, can make skin white inside deeply red like baby.`,
            desc2: `Recommended use: Apply evenly on face and neck (if needed) after cleansing or before applying makeup to keep skin hydrated and brighten skin tone.`
          }
        ]
      },
      productshowlist: [
        {
          id: 1,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro1.png',
          path: ''
        },
        {
          id: 2,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro2.png',
          path: ''
        },
        {
          id: 3,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro3.png',
          path: ''
        },
        {
          id: 4,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro4.png',
          path: ''
        },
        {
          id: 5,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro5.png',
          path: ''
        },
        {
          id: 6,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro6.png',
          path: ''
        },
        {
          id: 7,
          text: '胶Collagen',
          images: 'https://index.cuican520.com/pro7.png',
          path: ''
        },
        {
          id: 8,
          text: 'Collagen',
          images: 'https://index.cuican520.com/pro8.png',
          path: ''
        }
      ]
    },
    service: { //  服务
      headtitle: 'Integrity',
      headtitle2: 'Enterprise development, service-oriented.',
      title: 'Professional customized service',
      more: `More details`, //  new add
      servicelist: [
        {
          id: 1,
          text: 'medical service',
          desc: 'Open the German anti-aging journey',
          path: 'medical'
        },
        {
          id: 2,
          text: 'consultation service',
          desc: 'One-stop solution for overseas investment immigration',
          path: 'consult'
        },
        {
          id: 3,
          text: 'Patent technology cooperation',
          desc: 'Overseas technical cooperation',
          desc2: 'Overseas (Germany) patents introduced into China',
          path: 'skill'
        }
      ]
    },
    contact: { //  联系我们
      title: 'Contact us',
      contacttype: [
        {
          title: 'Phone',
          content: '021-6227 8386'
        },
        {
          title: 'E-mail',
          content: 'cassie.chan@cuican520.com'
        },
        {
          title: 'Fax',
          content: '021-6227 8386'
        },
        {
          title: 'Address',
          content: 'Room 1502, Block B3, Suning Tianyu Plaza, 99 Danba Road, Putuo District, Shanghai, China'
        }
      ]
    },
    friends: { //  中国合作伙伴
      title: 'Chinese partners',
      friendslist: [
        {
          name: 'SHANGHAI JILANG INDUSTRY CO.,LTD'
        },
        {
          name: 'CFC'
        }
      ]
    },
    consult: { //  咨询服务
      consult_title_list: [
        {
          id: 1,
          text: 'Current status of immigration'
        },
        {
          id: 2,
          text: 'Why do we choose Germany'
        },
        {
          id: 3,
          text: 'Investment Project - Schloss Neuschwanstein, Germany'
        },
        {
          id: 4,
          text: 'Our process'
        },
        {
          id: 5,
          text: 'Strength display'
        },
        {
          id: 6,
          text: 'Our advantage'
        }
      ],
      immigrantproduce1: 'The most reliable result of immigration is getting a green card.',
      immigrantproduce2: 'German immigrants are divided into skilled immigrants and investment immigrants. The least expensive, simplest, safest and highest success rate of immigration is',
      immigrantproduce3: 'Investment immigration',
      immigrantproduce4: '.Article 21 of the German Alien Residence Act stipulates that the nature of investment in entrepreneurial immigrants, that is, the applicant must start and operate a company, achieve self-employment for 5 years, and meet the business conditions expected by the local government, then apply.',
      immigrantproduce5: 'German permanent residency',
      immigrantproduce6: '(commonly known as the green card).Hold a long-term residence permit in Germany for 5 years, ensure a safe life, pay 60 months of social insurance premiums, have economic activity (work) permission, have a certain understanding of German, have a legal and social order, and live in Germany. Have a basic understanding, and family have enough living space. For applicants who choose a corporate visa, Article 21 of the German Immigration Act, a self-employed person (business owner or freelancer) who meets the following three points may be granted a residence permit and may be permanently transferred after holding the residence permit for 3 years. Residence: 1. Meet the special needs of the upper economic interests or regional; 2. The company‘s business is expected to have a positive impact on the economy; 3. It can guarantee the funds required by the company through its own capital or loans.',
      whycheckGermany1: `Investment immigration, three reasons to choose Europe's strongest economy over Germany: cultural and political stability, strict compliance with laws and order, high welfare security, a family to Germany, will enjoy quality education resources, a sound medical system, high-quality life In addition, Germany is also an investment land. Germany has a stable profit margin for investors with its good trade order. Germany includes family reunion category, accounting for 32% of the total quota; and skilled immigrant category, accounting for 68% of the entire quota; 38% are employer sponsorship categories; 34% are independent skilled immigrant categories; 22% are state government guarantee categories; 6% are business immigration categories, and additional technology, technology, and manufacturing bases can be integrated into the most effective resources.`,
      whycheckGermany2: `Germany belongs to the Schengen country. It has obtained German visas and green cards. It is unimpeded in other EU countries. After obtaining the German green card, it is basically no problem to apply for visas from other countries.`,
      newcastle: `German: Schloss Neuschwanstein, the full name of the Neuschwanstein Castle, was built in the late 19th century in the south-west of Bavaria, near the early Schloss Hohenschwangau (Hohenschwangau), about Fussen 4 km away from the border between Germany and Austria. Neuschwanstein Castle is a symbol of Germany. Because it is the prototype of Disney Castle, it is also called Snow White Castle. Built in 1869. This castle is one of the palaces of King Ludwig II of Bavaria. There were 360 rooms, of which only 14 were completed according to the design, and the other 346 rooms were not completed because of the death of the King in 1886. It is the most photographed building in Germany and one of the most popular tourist attractions. The average number of visitors to Neuschwanstein is about 1.3 million per year, of which more than 70% are Chinese and have strong shopping potential.`, //  new add
      newcastleimglist: [
        {
          desc: 'Bavaria, Germany must go to the sights',
          img: 'https://index.cuican520.com/cg1.png'
        },
        {
          desc: 'Winter Romance City Ice Snow City',
          img: 'https://index.cuican520.com/cg2.png'
        },
        {
          desc: '',
          img: 'https://index.cuican520.com/cg3.png'
        },
        {
          desc: '',
          img: 'https://index.cuican520.com/cg4.png'
        }
      ],
      flow: 'Strahlend，One-stop investment immigration of duty-free shops. First, we are authorized by the applicant to exercise on behalf of the applicant. Secondly, we spend 4 million euros, sign loan documents, company legal documents, obtain 51% of the shares, apply for a work visa, and then get a job. Visa, according to the requirements of the work permit, once every 186 days, the final work will be transferred to the green card. After 5 years of normal business operation, the company will transfer the green card. The full amount of 4 million euros will be returned to 51% of the shares.',
      showStrength: [
        {
          title: 'Ornee Duty free shop',
          desc: 'Located in Düsseldorf, a collection of major brands: MWF Zwilling Montblanc Fissher Lamy and other Chinese duty-free shops.',
          img: 'https://index.cuican520.com/sg1.png'
        },
        {
          title: 'Heidelberg',
          desc: 'It was built in 1869. This castle is one of the palaces of the Bavarian King Ludwig II. It is the most photographed building in Germany and one of the most popular tourist attractions. On average, the number of people visiting Neuschwanstein is about 1.3 million, of which more than 70% are Chinese and have strong shopping potential.',
          img: 'https://index.cuican520.com/sg2.png'
        },
        {
          title: 'SHANGHAI JILANG INDUSTRY CO.,LTD',
          desc: 'The business covers the domestic raw materials business unit and the foreign service business unit, and independently developed an e-commerce business unit.',
          img: 'https://index.cuican520.com/sg3.png'
        },
        {
          title: 'Xiamen Zunlang Biological Engineering Co.Ltd',
          desc: 'In charge of import and export trade',
          img: 'https://index.cuican520.com/sg4.png'
        }
      ],
      advantage: [
        {
          title: 'whenever necessary',
          text: 'Signing the contract, effective immediately, saving time for various regulatory processes'
        },
        {
          title: 'anywhere',
          text: 'Professional service company fully cooperates with and operates'
        },
        {
          title: 'Zero risk',
          text: 'Full refund, no need to bear the risk of legal person'
        },
        {
          title: 'Zero language threshold',
          text: 'No need for language tools such as English and German'
        },
        {
          title: 'good time',
          text: 'The door of the project will only be opened for you.'
        },
        {
          title: 'Good prospects',
          text: 'Join an experienced team for more opportunities'
        }
      ],
      mark: '*If you have any questions, please feel free to contact us, we will be happy to help you, thank you for your support!'
    },
    skill: { //  专利技术合作
      title: `How to apply for a patent`,
      desc: {
        title: `Patents are divided into three categories: invention patents, utility patents, design patents`,
        list: [
          {
            text: `Approval process for invention patents: patent application—acceptance—initial review—announcement—substantive review request—substantive review—authorization`
          },
          {
            text: `Utility model patent application approval process: patent application - acceptance - preliminary review - announcement - authorization`
          },
          {
            text: `Process for applying for a patent for appearance: patent application—acceptance—preliminary review—announcement—authorization`
          }
        ]
      },
      overseas: {
        title: `Overseas patent introduction`,
        desc: `Overseas (German) patents were introduced into China, and patents were filed in China. Overseas (Germany) required a lawyer's fee of 20,000 Euros for work applications, but only 20,000 RMB for lawyers.`,
        service: `We can also provide the following services:`,
        list: [
          {
            text: `Trademark registration`
          },
          {
            text: `Patent registration`
          },
          {
            text: `Introducing overseas science and technology---German electronic black technology and biotechnology`
          },
          {
            text: `Imported goods filing`
          },
          {
            text: `Commissioned processing (Germany, China)`
          }
        ]
      }
    },
    data: { //  隐私和数据保护
      title: 'Privacy and data protection',
      othertitle: `Strahlend' understand the importance of privacy to you and respect your privacy. Please read and understand these terms before submitting your personal data.`,
      datalist: [
        {
          id: 1,
          title: '1、Personal information',
          text: 'When you visit our website, we will not collect any personal information from you unless you voluntarily provide it. If you do not wish to provide us with personal information, you can still visit our website.'
        },
        {
          id: 2,
          title: '2、Way of collecting information',
          text: 'If you visit the 丝 website, we do not require personal information, but collect personal information on a voluntary basis, including but not limited to: your name, address, electronic number and email address'
        },
        {
          id: 3,
          title: '3、The way you use your information',
          text: 'In the case where certain services are provided by an authorized partner of Silkland, Silkland will share your personal data with the partner as described in this policy. In the case of applicable legal requirements or in response to legal proceedings, Estuilan may also disclose your personal data to relevant law enforcement agencies or other government agencies. Strahlend also discloses your data in the presence of reasonable demand, for example, due to the execution of the contract and the disclosure and disclosure that we believe is necessary to prevent physical damage or property damage or to investigate possible or actual illegal acts.'
        },
        {
          id: 4,
          title: '4、Integration and statistics',
          text: 'Strahlend uses the web to record information to help us design websites, identify hot featured products, and use it for other management purposes. However, if necessary, we use website records to help identify if someone wants to break into or break our website, and if we believe there is evidence of computer damage or violations of the law, we will share the website record with law enforcement. .'
        },
        {
          id: 5,
          title: '5、Data security and responsibility ',
          text: `Strahlend Commitment: We will protect the security of the data you provide to us and take reasonable precautions to prevent your personal information from being lost, misused or altered. In view of the presence of your company's personal information, we ask them to keep this information confidential and not to use it in any other way than to provide services in Silkland.`
        },
        {
          id: 6,
          title: '6、Update of this policy',
          text: 'Strahlend reserves the right to update or modify this policy from time to time. If our privacy policy changes, we will post the latest version of our privacy policy here.'
        },
        {
          id: 7,
          title: '7、Contact information',
          text: 'If you have provided personally identifiable information through a website or interactive advertisement of the Strahlend Company, or someone else has provided your personally identifiable information through the website of Strahlend or interactive advertising, and you wish to have this information To modify or delete from our database, please email us and provide us with the necessary information (the website you came from, name, and email), we will try our best to remove you from our documents. Personally identifiable information. If you want to ask for your personally identifiable information collected by the Strahlend website, Strahlend will try its best to provide you with such information and correct the real-time inaccuracies.'
        }
      ]
    },
    copyright: { //  版本说明
      title: 'Website copyright notice',
      othertitle: 'The website copyright statement is very grateful to you for your interest in our products and to visit our website. Please read all the terms of this statement carefully before using this website. By linking and using this website, you express your unconditional acceptance of this statement and you should be guilty of the relevant laws of this statement.',
      copyrightlist: [
        {
          id: 1,
          text: `The company's website retains all rights: all texts, images, audio files, animation files, and other intellectual property rights are protected by all relevant industrial property rights and intellectual property rights, including China's copyright law. It may not be copied for commercial purposes or distribution, and may not be modified for use on other websites.`
        },
        {
          id: 2,
          text: `All trademarks, logos and service marks appearing on this website are the property of the company. It may not be used, permanently downloaded, copied, or distributed in any way without the written permission of the Company's website division.`
        },
        {
          id: 3,
          text: `The contents and software of this website are protected by the Copyright Law of the People's Republic of China, the Copyright Law of the People's Republic of China, the provisions of international conventions on copyright protection, and other relevant laws and regulations. No unit or individual may use the content and services provided on this website for commercial or profitable activities; when using the content and services provided by this website for non-commercial purposes, it shall abide by the provisions of the Copyright Law and other relevant laws and regulations. Infringe the rights of website owners and related rights holders.`
        },
        {
          id: 4,
          text: `The company's website reserves the right to update the contents of this statement at any time according to the needs of the business. Please visit this page each time you visit this website to view the current statement content of this website.`
        },
        {
          id: 5,
          text: `Some graphic source network, if there is any infringement, please contact this site to delete.`
        },
        {
          id: 6,
          text: `The right to interpret the above statements is the property of the company's website.`
        }
      ]
    },
    medical: { //  海外医疗
      antiaging: 'Anti aging: the famous poet Xi Murong once said: youth is a book that is too hasty. Everyone from birth to death, youth may be a flash, a long and short life, aging is inevitable. With the acceleration of the aging population, the "old and old people" are common. Global research on aging and anti-aging has become increasingly active, anti-aging is an eternal topic in human medicine.', //  抗衰老
      howtoface: 'How to face?',
      naturaltherapy: [
        {
          id: 1,
          text: 'Medical examination'
        },
        {
          id: 2,
          text: 'Preliminary detoxification conditioning'
        },
        {
          id: 3,
          text: 'Stem cell depth repair'
        },
        {
          id: 4,
          text: 'Launching a German anti-aging journey'
        }
      ], //  自然疗法
      diymedical: [
        {
          id: 1,
          text: 'Entry of physical examination report',
          bgicon: 'https://index.cuican520.com/lg1.png'
        },
        {
          id: 2,
          text: 'DNA major disease detection',
          bgicon: 'https://index.cuican520.com/lg2.png'
        },
        {
          id: 3,
          text: 'Develop a personalized chemotherapy program',
          bgicon: 'https://index.cuican520.com/lg3.png'
        },
        {
          id: 4,
          text: 'Executive treatment plan',
          bgicon: 'https://index.cuican520.com/lg4.png'
        }
      ], //  体检建立当当
      gene: `Genetic testing: anti-aging gene testing package, chronic disease genetic testing package, male health genetic testing package, care for women's genetic testing package, happy children's genetic testing package, caring for the elderly genetic testing package.`, //  基因检测
      enginery: 'Heavy metal detoxification, allergen detoxification, acid-base balance and blood purification and detoxification',
      purify: `Blood purification and detoxification: "blood purification and detoxification" is a new health concept put forward by developed countries such as Europe and the United States. The lipids in plasma are collectively called blood lipids, including triglycerides, small amounts of diesters and monoglycerides, phospholipids, cholesterol and cholesterol esters, and non-esterified lipids. Excessive amounts of these lipids are blood toxins, especially the accumulation of heavy metals in the body caused by domestic environmental pollution. Blood purification and detoxification are carried out through German products. A device similar to a hemodialysis machine is used to separate human plasma, remove excess blood lipids, heavy metals, pesticides and other toxins using a German patent technology, and transfuse the filtered fresh and clean blood back into the body through another tube, which is equivalent to a sweep of the whole body's blood and restore the inner ring. At the same time, it can also play a very good role in delaying aging, increasing vitality, preventing cancer, eliminating inflammatory factors and preventing disease.`,
      exp: 'Star case, Hong Kong star Wu XX',
      expdesc: `Xinhua BEIJING, Dec. 16, according to Taiwan's "Dongsen News" reported that Wu XX16 in Germany after blood purification, even miraculously restored hearing, but also let people know that his left ear hearing 10 years ago has only 10%, after the news exposure, so that fans are very distressed, he said that there is no pain, "no risk, It's just that the charge is not cheap.`,
      repair: `Among them, blood purification and detoxification: "blood purification and detoxification" is a brand new health concept put forward by developed countries such as Europe and the United States. The lipids contained in plasma are collectively referred to as blood lipids, including: triglycerides, small amounts of diglycerides and monoglycerides, phospholipids, cholesterol and cholesterol esters, and non-esterified lipids. Too much of these lipids are blood toxins, especially Because of the accumulation of heavy metals in the body caused by domestic environmental pollution, blood purification and detoxification is to separate the human body's plasma through a German hemodialysis machine. The German patented technology is used to remove excess blood lipids, heavy metals, pesticides and other toxins, and will filter. After the fresh and clean blood is returned to the body through another pipe, it is equivalent to a large sweep of the body's whole body blood, which can also restore the body's environmental circulation and also play a good role in delaying aging, increasing vitality and preventing cancer. Eliminate the role of inflammatory factors in preventing diseases.`,
      swot: [
        {
          id: 1,
          title: 'Young ten years old',
          desc: 'Syringe tube cell gland extract "fresh cell extract", activates the stem cells of the aging organs, and allows the internal organs to replace the aging cells. The direct effect from the inside to the outside is that there is no fatigue, energy, and allergies disappear. The quality of sleep is improved, the skin is delicate and translucent, and the body is young and ten years old.',
          bgc: 'background:#a25b67',
          descborder: 'border-bottom: 1px solid #ddd;padding:0px 20px 20px 0;'
        },
        {
          id: 2,
          title: 'Nobel Prize in Physiology or Medicine',
          desc: 'Günter Blobel,German American biologist was awarded the Nobel Prize in Physiology or Medicine for discovering signal peptides. Protein targeting: The "address tag" signal peptide directs the newly synthesized protein molecule to the appropriate location within the cell.',
          bgc: 'background:#fcd1ab',
          descborder: 'border-left: 1px solid #ddd;padding:0px 0px 20px 20px;'
        },
        {
          id: 3,
          title: 'Activated organ stem cells',
          desc: 'According to the different conditions of each person, different organ cell extracts are selected, for example, thymus essence is used for human immunity, spleen cell extract extracts to restore hematopoiesis, liver cell extracts improve liver detoxification function, and corresponding placenta regulates body hormone levels. In addition, there are cell extracts such as heart, kidney, lung, bone and joint, testis, mesenchymal stem cells, etc. These growth factors work through their "home-seeking" principle to find their own target organs, activate stem cells, and generate information. Reporting the replacement of aging cells to restore and restore the function of this organ.',
          bgc: 'background:#493c3c',
          descborder: 'border-right: 1px solid #ddd;padding:30px 20px 20px 0;'
        },
        {
          id: 4,
          title: 'Upgrade of amphotericin',
          desc: 'Swiss surgeons extract sheep placenta from lamb embryos for cell therapy and improve immunity. In the 1970s, a new generation of products, cell organ gland extracts, was developed. This treatment avoids allergies caused by cells. Breaking the cell membrane of specific organs, removing the cell membrane with antigen by high-speed centrifugation, purifying the growth factor in the cell, directly freezing, without adding any preservative, colleagues will test all the samples for virus and bacteria, and fully use the medical standard before they are used in the human body.',
          bgc: 'background:#cc816e',
          descborder: 'border-top: 1px solid #ddd;padding:30px 0px 20px 20px;'
        }
      ],
      aging: [
        {
          id: '1',
          text: `The blood report was given to a German doctor a week in advance, and the doctor developed a one-on-one treatment plan to eat according to the doctor's recipe three days before the treatment.`
        },
        {
          id: '2',
          text: 'The first day of detoxification, intravenous injection, heavy metal, intestinal detoxification, etc., the next day to receive anti-aging fresh cell extract + organ function conditioning, the third to the sixth day, a needle of cell essence + organ function conditioning.'
        },
        {
          id: '3',
          text: 'Medical expenses:',
          price: '￥59980，Including pick-up plane + accommodation + daily treatment pick-up, tourist visa and accommodation and other living expenses in Germany convalescent period',
          color: 'color:#c0979d'
        }
      ]
    },
    brand: {
      banner__title: 'Brand story',
      banner__desc: `The choice of Europe's most densely populated and economically developed North Rhine is to better integrate the best resources in Germany into the STRAHLEND in China, and to fulfill everyone's initial wishes.`,
      brand__title: [
        {
          title: 'The origin of the company'
        },
        {
          title: 'Strahlend E-commerce platform (cross-border e-commerce APP)'
        }
      ],
      brand__origin: {
        part2: `On the winter night of Christmas, the friends sit around and the fireplace is warm and comfortable. The German friend Thomas’s party in the old castle is immersed in the red wine. The room is filled with German enthusiasm and sorrow in the exotic. Lao Yao is a Wenzhou native who has lived in Germany for many years. He is also the president of the German Chinese Restaurant Association. He has opened three Chinese restaurants in Hamburg, Cologne and Bremen in Germany. The integrity management has accumulated a good reputation in the local area and is well received by local Germans. favorite. Lao Yao's strict performance in the procurement of ingredients, select the best local suppliers to cooperate, each time the arrival of the goods are personally checked to ensure the freshness of the ingredients. Lao Yao’s parents still live in China, and China’s fake goods are rampant, food safety problems are frequent, and the situation is worrying. So Lao Yao often expresses German products to parents and relatives, while China Customs’s inspection rate of overseas parcels has increased. Many, food must be inspected, so it is impossible to return to China by courier. He is worried. Dr. Wang has been working at the German Institute for more than ten years. He is ready to return to China for development. He is accustomed to using German-quality goods. He is worried that he can't easily buy it after returning home, and domestic buyers are afraid to buy counterfeit fakes. Dr. Wang is more worried that after returning home, he will not be able to find the same high-quality raw materials as Germany for her research and the production of future biotechnology products.`,
        part3: ' “Why don’t we set up a company to solve everyone’s concerns?” Amin broke the silence. Amin is a friend of Thomas who is a guest in Germany. He has worked in international companies for many years, is optimistic and clear, and has clear ideas. He proposed to set up a company dedicated to German products. Chinese companies that export or even transform technology bring authentic German products to China, provide high-quality raw materials from Germany to Chinese conscience companies, and serve as a commercial bridge between China and Germany to serve domestic consumers. Excellent products are exported to Germany. Lao Jiang opened duty-free shops and jewellery watches in Germany. After years of good faith management, he became one of the best-selling duty-free shops in Germany. He has close ties with many German manufacturers and he can organize the best and authentic goods. The Chinese who travel in Germany often visit Chiang Kai-shek’s duty-free shops in Düsseldorf and Heidelberg’s watches, but because of the restrictions on luggage, the guests are very entangled in shopping, and the meaning is still unfinished. Lao Jiang hopes to serve the Chinese.'
      },
      cuicanApp: [
        {
          text: 'About Strahlend E-commerce platform concept'
        },
        {
          text: 'Create a shopping platform, create a high-quality life platform, and open up your life.'
        },
        {
          text: 'Four major life sectors：'
        },
        {
          text: '1. Medicine: Advance German natural therapy, combine traditional Chinese medicine to improve health, maintain youthful posture, improve various physiological skills, and effectively treat chronic diseases.'
        },
        {
          text: '2. Select the natural plant extracts from Germany, recommend functional foods and healthy foods, provide the daily nutrients needed by the human body, and protect the health.'
        },
        {
          text: '3.maintain beautiful appearance, recommended by the German Skin Institute, no added cosmetic skin care products, acne, eliminate acne marks, moisturizing anti-wrinkle, whitening to eliminate fine lines, dark spots, etc. '
        },
        {
          text: `4.Shape: Whether it's light luxury or heavy, whether it's clothing, bags or jewelry watches, it's a collection of European and international fashion.`
        },
        {
          text: 'We deliver quality service and personalized service. The target population is 109 million middle-class people who yearn for high-quality life, and also attract other consumers who demand quality of life.'
        },
        {
          text: 'The membership-based shopping platform can obtain different levels of membership through shopping points or direct recharge, enjoy the points exchange, and enjoy the benefits brought by the corresponding member discounts.'
        },
        {
          text: 'Overseas direct mail, free trade zone bonded warehouse fast customs clearance, the platform timely update product delivery information for members to consult. Legally declare customs clearance and abide by national laws and regulations.'
        }
      ],
      scanme: 'Scan download app'
    }
  }
}



// WEBPACK FOOTER //
// ./src/language/en.js